module.exports = "<div class=q-marg-all-xs-at-md> <a href=\"{%=detailsPageUrl %}&{%- portletNameSpace %}{%- discountsParam %}={%- discountsId %}\"> {%- discountsClassName %} </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/discounts/html/discountsDetailsLink.html
// module id = 1263
// module chunks = 1